module.exports = __webpack_public_path__ + "assets/img/scss_nesting.be8ffe5d.jpg";